// src/components/SectionCard.jsx
import React from "react";
import "./SectionCard.css"; // 若需额外样式，可新建对应 CSS 文件

const SectionCard = ({ title, descriptions }) => {
    return (
        <div className="section-card">
            <h3 className="section-card-title">{title}</h3>
            <ul className="section-card-list">
                {descriptions.map((desc, index) => (
                    <li key={index} className="section-card-item">
                        {desc}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default SectionCard;
